import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitRequestCriteriaFilter} from "./pit-request-criteria-filter";
import {PitRequestCriteriaSort} from "./pit-request-criteria-sort";
import {PitRequestCriteriaPage} from "./pit-request-criteria-page";

/** Набор критериев для выборки */

@jsonObject
export class PitRequestCriteria {

  /** Массив наименований полей, ожидаемых в ответе */
  @jsonArrayMember(String, {name: "fields", emitDefaultValue: false, isRequired: false})
  private _fields: string[] = [];

  /** Массив условий фильтрации выборки */
  @jsonArrayMember(PitRequestCriteriaFilter, {name: "filters", emitDefaultValue: false, isRequired: false})
  private _filters: PitRequestCriteriaFilter[] = [];

  @jsonArrayMember(PitRequestCriteriaSort, {name: "sorts", emitDefaultValue: false, isRequired: false})
  private _sorts: PitRequestCriteriaSort[] = [];

  @jsonMember({name: "page", constructor: PitRequestCriteriaPage, emitDefaultValue: false, isRequired: false })
  private _page: PitRequestCriteriaPage = new PitRequestCriteriaPage();


  get fields(): string[] {
    return this._fields;
  }

  set fields(value: string[]) {
    this._fields = value;
  }

  get filters(): PitRequestCriteriaFilter[] {
    return this._filters;
  }

  set filters(value: PitRequestCriteriaFilter[]) {
    this._filters = value;
  }

  get sorts(): PitRequestCriteriaSort[] {
    return this._sorts;
  }

  set sorts(value: PitRequestCriteriaSort[]) {
    this._sorts = value;
  }

  get page(): PitRequestCriteriaPage {
    return this._page;
  }

  set page(value: PitRequestCriteriaPage) {
    this._page = value;
  }

  constructor(fields?: Partial<PitRequestCriteria>) {
    if (fields)
      Object.assign(this, fields);
  }
}
